// @ts-nocheck
import { Plugin } from '/vercel/path0/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','qiankun','dva',],
});

export { plugin };
